import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BlIcon } from '@blend/shared-react';
import { RawLinkButton } from '@blend/consumer-components';

const styles = StyleSheet.create({
  link: {
    display: 'block',
  },
  backButton: {
    color: 'inherit',
    display: 'flex',
    font: 'inherit',
    fontSize: 'inherit',
    letterSpacing: 'inherit',
    lineHeight: 'inherit',
    pointerEvents: 'auto',
    cursor: 'pointer',
  },
  backArrow: {
    display: 'inline',
    paddingRight: 10,
    position: 'relative',
    top: '10%',
  },
});

function goBack(_e): void {
  history.go(-1);
}

interface ArrowBackButtonProps {
  onClick?: (_e: any) => void;
}

export default class ArrowBackButton extends React.Component<ArrowBackButtonProps> {
  render() {
    const { onClick } = this.props;
    // href hack for cross browser compatibility
    // http://simonthegeek.com/technical/history-back-problems-with-chrome-and-safari/
    return (
      <RawLinkButton className={css(styles.link)} type="button" data-it="ArrowBackButton" onClick={onClick || goBack}>
        <span className={css(styles.backButton)}>
          <span className={css(styles.backArrow)}>
            <BlIcon icon="date-arrow-left" />
          </span>
          Back
        </span>
      </RawLinkButton>
    );
  }
}
